import { defineComponent, h, PropType } from 'vue';
import { coming_soon } from '@components/icons';
import { has_reference_objects } from '../../non_graphical_ui_actions';
import { State } from '../../state';
import BarButton from '@components/bar-button';
import save_stl_svg from '../../../assets/img/SVG_icons/Top/reference_operation/save_ref_stl.svg';
import { img } from '@phi/components';
import { SessionType } from '@phi/authentication/frontend';
import { save_reference_model_to_STL } from '@frontend/import_3d_scan_data';
import SaveSTLTooltip from './SaveSTLTooltip';
import { ISubscriptions } from '@phi/subscriptions/frontend';

export const SaveSTLIcon = save_stl_svg;

export default defineComponent({
    props: {
        state: {
            required: true,
            type: Object as PropType<State>,
        },
        session_type: { required: true, type: null as any as PropType<Set<SessionType>> },
        subscriptions: { required: true, type: Object as PropType<ISubscriptions> },
    },

    computed: {
        coming_soon() {
            return !this.state.loaded;
        },

        alt() {
            return 'Save cropped STL to file';
        },

        disabled() {
            return !this.state.loaded
                || (
                    this.state.framework !== 'onshape'
                    && !this.session_type.has('onshape')
                )
                || !this.state.showing_reference_stl
                || !has_reference_objects();
        },
    },

    watch: {
        disabled(value: boolean) {
            this.$emit('update:disabled', value);
        },
    },

    emits: {
        'update:disabled': (x: boolean) => true,
    },

    methods: {
        onClick() {
            if (this.disabled)
                return;
            else if (this.subscriptions.state.subscription_status.value === 'starter')
                this.subscriptions.show_pro_feature_modal();
            else
                save_reference_model_to_STL();
        },
    },

    render() {
        return h(BarButton, {
            id: 'save-ref-stl-button',
            onClick: this.onClick,
            active: false,
            selected: this.state.tut_stage === 13,
            disabled: this.disabled,
            tippy: 'top',
            help: 'save_cropped_stl',
            pro_indicator: this.subscriptions.state.subscription_status.value === 'starter',
        }, {
            icon: () => this.coming_soon ? coming_soon(this.alt) : img(save_stl_svg, this.alt),
            tooltip: SaveSTLTooltip,
        });
    },
});
